import clsx from 'clsx'
import { Link } from './link'

export function Text({ className, ...props }: React.ComponentPropsWithoutRef<'p'>) {
  return (
    <p
      data-slot="text"
      {...props}
      className={clsx(className, 'text-base/6 text-[color:var(--theme-muted)] sm:text-sm/6')}
    />
  )
}

export function TextLink({ className, ...props }: React.ComponentPropsWithoutRef<typeof Link>) {
  return (
    <Link
      {...props}
      className={clsx(
        className,
        'text-[color:var(--theme-fg)] underline decoration-[color:var(--theme-border-strong)] data-hover:decoration-[color:var(--theme-fg)]',
      )}
    />
  )
}

export function Strong({ className, ...props }: React.ComponentPropsWithoutRef<'strong'>) {
  return (
    <strong {...props} className={clsx(className, 'font-medium text-[color:var(--theme-fg)]')} />
  )
}

export function Code({ className, ...props }: React.ComponentPropsWithoutRef<'code'>) {
  return (
    <code
      {...props}
      className={clsx(
        className,
        'rounded-sm border border-[color:var(--theme-border-soft)] bg-[color:var(--theme-hover)] px-0.5 text-sm font-medium text-[color:var(--theme-fg)] sm:text-[0.8125rem]',
      )}
    />
  )
}
